import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import { CarouselMediaBannerWrapperComponent } from "./carousel-media-banner-wrapper.component";

@NgModule({
	imports: [CommonModule],
	declarations: [CarouselMediaBannerWrapperComponent],
	exports: [CarouselMediaBannerWrapperComponent],
})
export class CarouselMediaBannerWrapperModule {}
